"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2885],{

/***/ 2885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SectionHeader_SectionHeader; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../wif-ui-lib/dist/SectionHeader.js
var SectionHeader = __webpack_require__(933);
// EXTERNAL MODULE: ./src/contexts/EmployerSiteContext.tsx
var EmployerSiteContext = __webpack_require__(981);
;// CONCATENATED MODULE: ./src/magnolia/components/SectionHeader/SectionHeader.tsx



function SectionHeader_SectionHeader(param) {
    var heading = param.heading, anchorTag = param.anchorTag, leadText = param.leadText, backgroundColor = param.backgroundColor;
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* SectionHeader */.M, {
        id: anchorTag,
        leadText: leadText,
        backgroundColor: backgroundColor !== "white" ? isEmployerSite ? "gray" : "lightBlue" : "white",
        children: heading
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/SectionHeader/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ f; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4877);



const m = "section-header", p = "section-header__heading", l = "desktop", h = "section-header__lead-text", L = "section-header--noGap", y = "section-header--lightBlue", u = "section-header--gray", t = {
  sectionHeader: m,
  sectionHeaderHeading: p,
  desktop: l,
  sectionHeaderLeadText: h,
  sectionHeaderNoGap: L,
  sectionHeaderLightBlue: y,
  sectionHeaderGray: u
};
function f({
  id: c,
  leadText: n,
  backgroundColor: i,
  children: e
}) {
  const r = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    i === "lightBlue" ? t.sectionHeaderLightBlue : i === "gray" && t.sectionHeaderGray
  ), H = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => !!e && (typeof e != "string" || !!e.trim()),
    [e]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B,
    {
      id: c,
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL,
      className: r
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Content, { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(n && t.sectionHeaderNoGap) }, H && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "h2",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.headingSection,
          t.sectionHeaderHeading
        ),
        "data-testid": "section-header"
      },
      e
    ), n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "p",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
          _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsComponentTitle,
          t.sectionHeaderLeadText
        ),
        "data-testid": "section-header-lead-text"
      },
      n
    ))
  );
}

//# sourceMappingURL=SectionHeader.js.map


/***/ })

}]);